import { css } from '@linaria/core';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import { dlEventSend } from 'gatsby-plugin-purina-analytics/common/functions';
import React, { useEffect, useState } from 'react';
import SignUpIcon from 'src/assets/icons/signup-icon';
import VirtualTourIcon from 'src/assets/icons/virtual-tour-icon';
import { getHtmlAttributes } from 'src/utils/paragraphHelpers';
import { theme } from '../theme/theme';
import Link from './Link';
import SignUpForm from './forms/SignUpForm';

const iconClass = css`
  margin-left: 0.5rem;
`;

const liClass = css`
  @media (min-width: ${theme.media.lg}) {
    border-right: 1px solid #fff;
  }
`;

const buttonClass = css`
  background: none;
  border: none;
  color: #fff;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;

const linkClass = css`
  @media (min-width: ${theme.media.lg}) {
    width: auto;
    margin: auto;
    text-align: center;
  }
`;

interface LinkListItemProps {
  link: LinkProps;
  border?: boolean;
  center?: boolean;
  dlEvent?: Object | undefined;
  section?: string;
}

const LinkListItem = ({ link, border, center, dlEvent, section }: LinkListItemProps) => {
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();

  const attributes = getHtmlAttributes(link.options?.attributes);
  const isFooter = section === 'footer';
  const Icon = attributes?.sign_up ? SignUpIcon : VirtualTourIcon;
  const paramsKey = 'show_sign_up';

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.has(paramsKey)) {
      setShowModal(true);
    }
  }, [location.search]);

  const handleModal = (isOpen: boolean) => {
    setShowModal(isOpen);

    const params = new URLSearchParams(location.search);

    if (isOpen) {
      params.set(paramsKey, '');
    } else {
      params.delete(paramsKey);
    }

    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  if (attributes?.sign_up) {
    return (
      <li className="py-1 px-lg-3 d-flex">
        <button
          type="button"
          className={`${buttonClass}`}
          onClick={() => handleModal && handleModal(true)}
          aria-label={link.title}
        >
          {link.title} {!isFooter && Icon && <Icon className={iconClass} />}
        </button>
        <SignUpForm show={!!showModal} handleClose={() => handleModal && handleModal(false)} />
      </li>
    );
  }

  return (
    <li className={`py-1 px-lg-3 d-flex ${border && liClass}`}>
      {link.uri === 'route:<nolink>' ? (
        <div {...attributes}>{link.title}</div>
      ) : (
        <Link
          to={link.url}
          {...attributes}
          className={`align-items-center ${center && linkClass}`}
          onClick={() => dlEventSend(dlEvent)}
        >
          {link.title} {!isFooter && Icon && <Icon className={iconClass} />}
        </Link>
      )}
    </li>
  );
};

export default LinkListItem;
